import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';


import { API_LINK } from '../../constants';
import moment from 'moment';
import { turnitinDoSubmissionFailure, turnitinDoSubmissionRequest, turnitinDoSubmissionSuccess, turnitinGenerateFailure, turnitinGenerateRequest, turnitinGenerateSuccess } from '../reducers/turnitin';

const API = `${API_LINK}api`;



function* turnitinGenerateFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { statementid } = state.turnitinReducer;
  const {
    user,
    token,
  } = state.loginReducer;

  
  const response = yield call(() =>
    axios({
      method: 'put',
      url: API+'/assessor/tii_generateReport',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Uploaaded-With': 'XMLHttpUploaad',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        statementid: statementid,
      },
    }),
  );

  return response;
}

function* workerTurnitinGenerateSaga() {
  try {
    const response = yield call(turnitinGenerateFunctionAxios);
    const responseFromTurnitinGenerate = response.data;
   
    if (response.status === 200) {
      yield put(turnitinGenerateSuccess(responseFromTurnitinGenerate));
    }
    if (response.status === 201) {
      yield put(turnitinGenerateFailure(responseFromTurnitinGenerate.message));
    }
  } catch (error) {
    yield put(turnitinGenerateFailure(error.message));
  }
}

export function* watcherTurnitinGenerateSaga() {
  
  yield takeLatest(turnitinGenerateRequest().type, workerTurnitinGenerateSaga);
}
